import React, {useMemo, useState} from 'react';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import TalentCandidate from "../../../models/TalentCandidate";

const CandidateSort = ({sortBy, onChange = () => true, options = TalentCandidate.matchSortingOptions(),...props}) => {

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const activeSort = useMemo(() => {
        return options[sortBy] || TB.first(Object.values(options))
    }, [sortBy])

    return (
        <Dropdown
            className="project-sort-teams-dropdown"
            isOpen={dropdownOpen}
            toggle={() => setDropdownOpen(!dropdownOpen)}>

            <DropdownToggle caret tag="a" className="positionFilterToggleButton">
                <span className="text-black">
                    Sort:
                </span>
                <span className={"text-primary"}>&nbsp;&nbsp;{activeSort}</span>
            </DropdownToggle>

            <DropdownMenu>
                {TB.map(options, (label, key) => (
                    <DropdownItem
                        key={key}
                        className={TB.mapClass({active: key === sortBy})}
                        style={{fontSize: '12px'}}
                        onClick={() => onChange(key)}>
                        <span>{label}</span>
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default CandidateSort;